import axios from 'axios'
import router from '@/pages/user/router'
import Swal from 'sweetalert2'
const v = require('../config')

const generateAPIEndPoint = () => {
    if (process.env.NODE_ENV === 'production') {
        return 'https://pub-api.nsgplay.net/'
    }
    return 'https://pub-api.nsgplay.net/' // http://localhost:5000/api/v1
}

export const API_ENDPOINT = generateAPIEndPoint()

const instance = axios.create({
    baseURL: API_ENDPOINT,
})
instance.interceptors.request.use(async(config) => {
    config.headers['Content-Type'] = 'application/json'
    let token = localStorage.getItem('AccessToken')
    return {
        ...config,
        headers: {
            ...config.headers,
            ... { 'Accept-Language': 'th' },
            ...(v.SecertKey && { 'api-key': v.SecertKey }),
            ...(token && { 'api-auth': token }),
        },
    }
})
instance.interceptors.response.use(
    (response) => {
        return response.data
    },
    async(err) => {
        if (err.response) {
            if (err.response.status === 401) {
                if (
                    router.history.current.name != 'Login' &&
                    router.history.current.name != 'Signup' &&
                    router.history.current.name != 'Home' &&
                    router.history.current.name != 'Join' &&
                    router.history.current.name != 'Not Found'
                ) {
                    await router.push('home').catch(() => {})
                }
            }
            return err.response.data
        }
        return Promise.reject({
            status: {
                code: 0,
                message: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ในขณะนี้',
            },
        })
    }
)
export default instance


// WEBPACK FOOTER //
// ./src/services/index.js